<template>
  <div>
    <AppHeader :breadcrumbsItems="items" :title="' Laboratorio de Inteligencia'" />
    <v-row>
      <v-col>
        <v-card class="iframe-container">
          <iframe 
            title="informe sistema mixto" 
            src="https://app.powerbi.com/view?r=eyJrIjoiODI4ZjA0NWMtMTNlNi00NDFkLTk2OGEtY2MwMzBjODg1MzJkIiwidCI6IjYwYzJjMGQ4LTFlZTEtNDljYy1hNmMwLWE3Njc1NmUxN2M4YiJ9&pageName=ReportSection" 
            frameborder="0" 
            allowFullScreen="true"
            class="responsive-iframe">
          </iframe>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppHeader from "../components/dashboard/AppHeader.vue";




export default {
  name: "AdminServiciosView",
  components: {
    AppHeader,
  },
  created() {
    
  },
  data() {
    return {
      
    };
  },
  
  
};
</script>

<style lang="scss">
.iframe-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 150px);
  overflow: hidden;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
